import React from 'react';

function NavigationBar({ currentPage, isLoggedIn, navigateTo, userProfile }) {
  const navLinks = [
    { id: 'landing', label: 'Home', page: 'landing' },
    { id: 'difficulty', label: "Today's Puzzle", page: 'difficulty' },
    { id: 'leaderboard', label: 'Leaderboard', page: 'leaderboard' },
    { id: 'founder', label: 'Founder', page: 'founder' },
    { id: 'about', label: 'About', page: 'about' }
  ];

  // Add admin link if user is admin
  if (userProfile?.is_admin) {
    navLinks.push({ id: 'admin', label: '⚙️ Admin', page: 'admin' });
  }

  return (
    <nav style={{
      position: 'sticky',
      top: 0,
      zIndex: 100,
      background: 'rgba(30, 58, 138, 0.95)',
      backdropFilter: 'blur(10px)',
      borderBottom: '1px solid rgba(255, 255, 255, 0.1)',
      padding: '12px 32px'
    }}>
      <div style={{
        maxWidth: '1200px',
        margin: '0 auto',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'space-between'
      }}>
        {/* Logo */}
        <button
          onClick={() => navigateTo('landing')}
          style={{
            background: 'none',
            border: 'none',
            color: 'white',
            fontSize: '20px',
            fontWeight: '800',
            cursor: 'pointer',
            padding: '0',
            letterSpacing: '-0.5px'
          }}
          onMouseEnter={(e) => {
            e.target.style.opacity = '0.8';
          }}
          onMouseLeave={(e) => {
            e.target.style.opacity = '1';
          }}
        >
          SudokuMatch
        </button>

        {/* Center Links */}
        <div style={{
          display: 'flex',
          gap: '8px',
          alignItems: 'center'
        }}>
          {navLinks.map(link => (
            <button
              key={link.id}
              onClick={() => navigateTo(link.page)}
              style={{
                background: currentPage === link.page 
                  ? 'rgba(255, 255, 255, 0.15)' 
                  : 'transparent',
                border: 'none',
                color: 'white',
                padding: '8px 16px',
                fontSize: '14px',
                fontWeight: '600',
                cursor: 'pointer',
                borderRadius: '8px',
                transition: 'all 0.2s ease'
              }}
              onMouseEnter={(e) => {
                if (currentPage !== link.page) {
                  e.target.style.background = 'rgba(255, 255, 255, 0.1)';
                }
              }}
              onMouseLeave={(e) => {
                if (currentPage !== link.page) {
                  e.target.style.background = 'transparent';
                }
              }}
            >
              {link.label}
            </button>
          ))}
        </div>

        {/* Right Side - Login/Account */}
        <button
          onClick={() => navigateTo(isLoggedIn ? 'account' : 'login')}
          style={{
            background: isLoggedIn ? 'rgba(255, 140, 0, 0.2)' : '#FF8C00',
            border: isLoggedIn ? '1px solid #FF8C00' : 'none',
            color: 'white',
            padding: '8px 20px',
            fontSize: '14px',
            fontWeight: '700',
            cursor: 'pointer',
            borderRadius: '8px',
            transition: 'all 0.2s ease',
            boxShadow: isLoggedIn ? 'none' : '0 2px 8px rgba(255, 140, 0, 0.3)'
          }}
          onMouseEnter={(e) => {
            if (isLoggedIn) {
              e.target.style.background = 'rgba(255, 140, 0, 0.3)';
            } else {
              e.target.style.background = '#E07B00';
            }
          }}
          onMouseLeave={(e) => {
            if (isLoggedIn) {
              e.target.style.background = 'rgba(255, 140, 0, 0.2)';
            } else {
              e.target.style.background = '#FF8C00';
            }
          }}
        >
          {isLoggedIn ? '👤 Account' : 'Login / Register'}
        </button>
      </div>
    </nav>
  );
}

export default NavigationBar;
